import EquipSplashScreen from "@/ui/components/splashScreen/EquipSplashScreen";
import { isWeb } from "@/utils/platform.util";

const Screen = () => {
  // on web, the /myequip callback renders a splash, and then routes here to render another
  // this second splash having a non-zero transition results in a "flash" of disappeaaring/re-appeaaring

  // on mobile, fallback to the default transitionMs
  const transitionMs = isWeb() ? 0 : undefined;
  return <EquipSplashScreen transitionMs={transitionMs} />;
};

export default Screen;
